export const saveUser = (data) => ({
  type: "SAVE_USER",
  data: data,
});

export const saveAddress = (address) => ({
  type: "SAVE_ADDRESS",
  data: address,
});

export const setCurrentLocation = (address) => ({
  type: "SET_CURR_LOCATION",
  data: address,
});

export const fetchCart = (cart) => ({
  type: "FETCH_CART",
  data: cart,
});

export const addToCart = (data) => ({
  type: "ADD_TO_CART",
  data,
});

export const removeFromCart = (data) => ({
  type: "REMOVE_FROM_CART",
  data,
});

export const clearCart = (data) => ({
  type: "CLEAR_CART",
  data,
});
export const saveBillDetails = (data) => ({
  type: "SAVE_BILL_CHECKOUT",
  data,
});
export const onlinePaymentDetails = (data) => ({
  type: "ONLINE_PAYMENT_DETAILS",
  data,
});
export const clearOnlinePaymentDetails = (data) => ({
  type: "CLEAR_ONLINE_PAYMENT_DETAILS",
  data,
});

export const utmLoad = () => ({ type: "UTM_LOAD" });

export const clearAll = () => ({ type: "CLEAR_ALL" });
